
    let lock = false;
    let bgColor = ["#F2F2F2","#F2F2F2","#F2F2F2"];
    let headerH= document.querySelector(".header-section").offsetHeight;
    let announcementBarH= document.querySelector(".announcement-bar-section")?document.querySelector(".announcement-bar-section").offsetHeight:0;
  
    let swiperHeight=0;
    let isVideo = false;
    if(document.querySelector(".img-box img")){
        swiperHeight = document.querySelector(".img-box img").offsetHeight;
    }else{
        swiperHeight = document.querySelector(".slideshow__slide-video-bg video").offsetHeight;
        isVideo=true;
    }
    let swiperContainerEl=document.querySelector(".swiper-container")
    if(window.window.innerWidth > 768){
        document.querySelector(".main-index").style.marginTop = swiperHeight - 2 +'px';
        if(document.querySelector("#epb_container")&&announcementBarH==0){
            announcementBarH=68;
            document.querySelector(".main-index").style.marginTop = swiperHeight - 2 + announcementBarH +'px';
        }
        swiperContainerEl.style.top = headerH+announcementBarH + 'px';
        swiperContainerEl.style.height = swiperHeight + 'px';
    }else{
        if(!isVideo){
            swiperHeight=document.querySelector(".img-box .slideshow-image--mobile").offsetHeight;
        }else{
            swiperHeight=document.querySelector(".moblie_video .slideshow__slide-video-bg video").offsetHeight;
        }
        swiperContainerEl.style.height = swiperHeight + 'px';
    }
    let autoplay=document.querySelector(".swiper-wrapper").getAttribute('autoplay');
    if(!isVideo){
        let mySwiper = new Swiper('.swiper-container',{
            speed: 1000,
            allowTouchMove: false,
            autoplay:{
                delay:autoplay,
            },
            parallax : true, 
            on:{
                transitionStart: function(){
                    lock = true;
                    slides = this.slides
                    imgBox = slides.eq(this.previousIndex).find('.img-box')
                    imgActiveBox = slides.eq(this.activeIndex).find('.img-box')
                    imgPrev = slides.eq(this.previousIndex).find('img')  
                    imgActive = slides.eq(this.activeIndex).find('img')  
                    derection = this.activeIndex-this.previousIndex
                    this.$el.css("background-color",bgColor[this.activeIndex]);
                    imgBox.transform('matrix(0.6, 0, 0, 0.6, 0, 0)');
                    imgBox.transition(1000).css('border-radius','20px');
                    imgActiveBox.transition(1000).css('border-radius','20px');
                    imgPrev.transition(1000).transform('matrix(1.2, 0, 0, 1.2, 0, 0)');
                    this.slides.eq(this.previousIndex).find('h3').transition(1000).css('color','rgba(255,255,255,0)');
                    imgPrev.transitionEnd(function () {
                    imgActive.transition(1300).transform('translate3d(0, 0, 0) matrix(1.2, 0, 0, 1.2, 0, 0)');
                    imgPrev.transition(1300).transform('translate3d('+60*derection+'%, 0, 0)  matrix(1.2, 0, 0, 1.2, 0, 0)');
                    });
                },
                transitionEnd: function(){
                    this.slides.eq(this.activeIndex).find('.img-box').transform(' matrix(1, 0, 0, 1, 0, 0)');
                    imgActiveBox = this.slides.eq(this.activeIndex).find('.img-box')
                    imgActive = this.slides.eq(this.activeIndex).find('img')
                    imgActive.transition(1000).transform(' matrix(1, 0, 0, 1, 0, 0)');
                    this.slides.eq(this.activeIndex).find('h3').transition(1000).css('color','rgba(255,255,255,1)');
                    imgActive.transitionEnd(function () {
                    lock = false
                    imgActiveBox.css('border-radius','0');
                    });
                    this.$el.find('.flickity-custom-navigation--current')[0].innerHTML = this.activeIndex+1
                },
                init:function(){
                    this.emit('transitionEnd');
                },
            
            }
        });
        mySwiper.$el.find('.flickity-next').on('click',function(){
            if(!lock){
                mySwiper.slideNext();
            }
        })
        mySwiper.$el.find('.flickity-prev').on('click',function(){
            if(!lock){
                mySwiper.slidePrev();
            }
        })	
    }
    if(window.innerWidth>768){
        window.onscroll = function() {
            let opacityCount=(document.documentElement.scrollTop || document.body.scrollTop) / 600
            if(opacityCount>1||opacityCount<0){
                return
            }
            document.querySelector('.scrollfadeout').style.display = opacityCount<0.1?'none':'block';
            document.querySelector('.scrollfadeout').style.opacity = opacityCount;
        }
    }

